import { render, staticRenderFns } from "./CustomerNotificationProcess.vue?vue&type=template&id=66856a88&"
import script from "./CustomerNotificationProcess.vue?vue&type=script&lang=js&"
export * from "./CustomerNotificationProcess.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports